function createCookie(name, value, days) {
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    var expires = "; expires=" + date.toGMTString();
  } else var expires = "";
  document.cookie = name + "=" + value + expires + "; path=/";
}

function createCookieMinutes(name, value, minutes) {
  if (minutes) {
    var date = new Date();
    date.setTime(date.getTime() + (minutes * 60 * 1000));
 
    var expires = "; expires=" + date.toGMTString();
  } else var expires = "";
  document.cookie = name + "=" + value + expires + "; path=/";
}

function readCookie(name) {
  var nameEQ = name + "=",
      ca = document.cookie.split(';');
  
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function erease(name) {
  createCookie(name, "", -1);
}


$(function(){
  $('a.fancybox-btn').fancybox({
  	onComplete: function(){
      
    },
    onCleanup: function(){
      // on fancybox close -- add cookie
      createCookieMinutes('popupDeclined', 1, 60);
    }
  })
  
  // check for cookie
  $('.product-form form').on('submit', function(){
    if (!readCookie('popupDeclined') && !readCookie('popup')) {
      $('a.fancybox-btn').trigger('click');
    }
  })
})